//
//
//
//
//

import { lazilyLoadImage } from '~/utils/tools';

export default {
  props: {
    // 实际url
    url: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      unObserve: () =>{},
    }
  },
  mounted() {
    const el = this.$slots.default?.[0]?.elm
    if (el && el instanceof HTMLImageElement) {
      this.unObserve = lazilyLoadImage(el, () => {
        // 加载
        el.src = this.url
      }, this.options)
    }
  },
  unmounted() {
    this.unObserve()
  }
}
